/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetInventoriesInQuery } from '../../models/get-inventories-in-query';
import { GetInventoriesInQueryResult } from '../../models/get-inventories-in-query-result';

export interface ApiNurseryManagerInventoryInGetInventoriesInPost$Plain$Params {
      body?: GetInventoriesInQuery
}

export function apiNurseryManagerInventoryInGetInventoriesInPost$Plain(http: HttpClient, rootUrl: string, params?: ApiNurseryManagerInventoryInGetInventoriesInPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetInventoriesInQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiNurseryManagerInventoryInGetInventoriesInPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetInventoriesInQueryResult>;
    })
  );
}

apiNurseryManagerInventoryInGetInventoriesInPost$Plain.PATH = '/api/NurseryManager/InventoryIn/GetInventoriesIn';
